/*$("#truncated").on("click", function () {
  $("#truncated").fadeOut(300, function () {
    $("#fullDescription").fadeIn(500);
  });
});
*/
$(document).on("change", ".template-cart .cart__terms-checkbox", function () {
  $(".cart__checkout-button").attr("disabled", function (_, attr) {
    return !attr;
  });
});
// Add custom code below this line
var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
var currentDateNew = new Date(new Date().getTime() + 0 * 60 * 60 * 1000);
var day = currentDateNew.getDate();
let dayN = "th";
switch (day) {
  case 1:
    dayN = "st";
    break;
  case 2:
    dayN = "nd";
    break;
  case 3:
    dayN = "rd";
    break;
  default:
    dayN = "th";
}
var month = currentDate.getMonth() + 1;
var year = currentDate.getFullYear();
var days = [
  "Søndag",
  "Mandag",
  "Tirsdag",
  "Onsdag",
  "Torsdag",
  "Fredag",
  "Lørdag",
];
const monthNames = [
  "januar",
  "februar",
  "marts",
  "april",
  "maj",
  "juni",
  "juli",
  "august",
  "september",
  "oktober",
  "november",
  "december",
];
$(".date-product").html(
  days[currentDateNew.getDay()] +
    " " +
    day +
    dayN +
    " " +
    monthNames[currentDateNew.getMonth()]
);

const myInterval = setInterval(function time() {
  var d = new Date();
  var d1 = new Date();
  var hoursOriginal = d.getHours();
  d.setHours(d1.getHours() + 10);
  var hours = 23 - d.getHours();
  var min = 59 - d.getMinutes();
  if ((min + "").length == 1) {
    min = "0" + min;
  }
  var sec = 59 - d.getSeconds();
  if ((sec + "").length == 1) {
    sec = "0" + sec;
  }



  

  if (
    days[currentDateNew.getDay()] == "Mandag" ||
    days[currentDateNew.getDay()] == "Tirsdag" ||
    days[currentDateNew.getDay()] == "Onsdag" ||
    days[currentDateNew.getDay()] == "Torsdag"
    ) {
    if (hoursOriginal >= 15) {
      $(".date-product--outer").html(
        "Bestil i dag og vi sender din pakke i morgen."
      );
      clearInterval(myInterval);
    }
  }






  
  if (hours == 0) {
    $(".timer").html(min + " min " + sec + " sek");
  } else {
    $(".timer").html(hours + " timer " + min + " min " + sec + " sek");
  }
  if (hoursOriginal >= 15) {
    $(".today-tomorrow-i").html("i morgen.");
  } else {
    $(".today-tomorrow-i").html("i dag.");
  }
  if (
    days[currentDateNew.getDay()] == "Lørdag" ||
    days[currentDateNew.getDay()] == "Søndag" ||
    days[currentDateNew.getDay()] == "Fredag"
  ) {
    if (days[currentDateNew.getDay()] == "Fredag") {
      if (hoursOriginal >= 15) {
        $(".date-product--outer").html(
          "Bestil i dag og vi sender din pakke på mandag."
        );
        clearInterval(myInterval);
      }
    } else if (days[currentDateNew.getDay()] == "Lørdag") {
      $(".date-product--outer").html(
        "Bestil i dag og vi sender din pakke på mandag."
      );
      clearInterval(myInterval);
    } else if (days[currentDateNew.getDay()] == "Søndag") {
      $(".date-product--outer").html(
        "Bestil i dag og vi sender din pakke i morgen."
      );
      clearInterval(myInterval);
    }
  }
}, 1000);

$(".short-description .read-more-btn").click(function () {
  $("#reach-here-scroll .summary__title").click();
});


$(".read-more-btn-product").click(function () {
  $(this).parent().slideUp().next().slideDown();
});

